
<template>
  <div class="grid">
    <div class="col-12">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-4 p-3">
          <div class="p-3 text-center bg-blue-900" style="border-radius: 12px">
            <span class="inline-flex justify-content-center align-items-center bg-blue-800 border-circle mb-3" style="width:49px; height: 49px">
              <i class="pi pi-shopping-cart text-xl text-white"></i>
            </span>
            <div class="text-2xl font-medium text-white mb-2">10</div>
            <span class="text-blue-100 font-medium">New Products Available</span>
          </div>
        </div>
        <div class="col-12 md:col-12 lg:col-4 p-3">
          <div class="p-3 text-center bg-bluegray-600" style="border-radius: 12px">
            <span class="inline-flex justify-content-center align-items-center bg-bluegray-500 border-circle mb-3" style="width:49px; height: 49px">
              <i class="pi pi-bookmark text-xl text-white"></i>
            </span>
            <div class="text-2xl font-medium text-white mb-2">5</div>
            <span class="text-white font-medium">Learning Modules</span>
          </div>
        </div>
        <div class="col-12 md:col-12 lg:col-4 p-3">
          <div class="p-3 text-center bg-orange-500" style="border-radius: 12px">
            <span class="inline-flex justify-content-center align-items-center bg-orange-600 border-circle mb-3" style="width:49px; height: 49px">
              <i class="pi pi-users text-xl text-white"></i>
            </span>
            <div class="text-2xl font-medium text-white mb-2">2K</div>
            <span class="text-orange-100 font-medium">Active Users</span>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 lg:col-6">
      <div class="shadow-2 surface-card border-round p-3" style="height:100%">
        <div class="border-bottom-1 surface-border">
          <span class="text-xl font-medium text-900">My Modules</span>
        </div>
        <div class="mt-3">
          <div class="grid">
            <div class="col-12 md:col-6 sm:col-12" v-for="(item, index) in Products" v-bind:key="index">
              <div class="text-center border-1 surface-border border-round p-4" style="height:100%">
                <img :src="item.productImageUrl" class="mb-3 w-full h-50" style="max-height:275px; max-width:200px" />
                <div class="text-600 text-xl font-100 my-1 font-bold">Interactive Study Guide</div>
                <Button label="About" class="p-button-sm p-button-outlined mt-1 p-button-raised border-orange-700 text-orange-700" icon="pi pi-info-circle" iconPos="left" />
                <Button label="Begin" class="p-button-sm  bg-orange-700 border-orange-700 mt-1 ml-2 p-button-raised" icon="pi pi-arrow-right" iconPos="right" @click="CourseStart(`${item.productId}`, `${item.productDescription}`)" :disabled="item.productStatus == 2000" />

                <InlineMessage severity="info" v-if="item.productStatus == 2000" class="w-full mt-2 bg-orange-700 text-white">You do not have access to this product</InlineMessage>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="lg:col-6 sm:col-12 md:col-12">
      <div class="shadow-2 surface-card border-round p-3" style="height:100%">
        <div class="border-bottom-1 surface-border">
          <span class="text-xl font-medium text-900">Latest Feed</span>
        </div>
        <div class="mt-3">
          <div class="grid">
            <div class="col-12">
              <div class="text-center border-1 surface-border border-round p-4">
                <iframe width="100%" height="370" src="https://www.youtube.com/embed/wRUtk0AuAuU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="surface-ground">
        <div class="surface-card shadow-2 border-round p-4">
          <div class="border-bottom-1 surface-border mb-4">
            <span class="text-xl font-medium text-900">Upcoming Events</span>
          </div>
          <ul class="list-none p-0 m-0">
            <li class="pb-3 border-bottom-1 surface-border">
              <div class="font-xl text-900 mb-2 font-bold">Shake The Nations Leadership Forum</div>
              <div class="line-height-3 text-900" style="max-width: 30rem">
              <b> September 13th - 15th </b>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</template>

<style>
  .p-inline-message.p-inline-message-info .p-inline-message-icon {
    color: white;
  }
</style>

<script>

  import Button from 'primevue/button';

  export default {
  name: 'UserDashboard',
    components: {
      Button
    },
    data: () => ({
      Products: [],
      ConnectModal: false
    }),
    created() {

      var self = this;

      this.$emit("set-nav", this.$route)
      this.$http.get('/ELearning/Products', {}).then(function (response) {
        self.Products = response.data
        self.Loading = false;
      })
    },
    methods: {
      CourseStart(productId, productName) {
        this.$router.push({ path: `/Courses`, query: { CourseId: productId, CourseName: productName } })
      }
  
    }
}</script>